<div fxLayout="column" fxLayoutAlign="start center" class="container">
  <h3>
    The account invitation is no longer valid.
    <br />
    Please contact your lineup administrator to receive another invitation.
  </h3>
</div>
